export default __webpack_public_path__ + "static/IBMPlexSans-SemiBoldItalic-Cyrillic-b649469b999b248dbb70d8e1821da001.woff";